module.exports = __webpack_public_path__ + "static/media/Source Info.1d1bfb04.txt";